var d2ChartsApi = require('./lib');

module.exports = d2ChartsApi;



/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/index.js
 ** module id = 191
 ** module chunks = 0 1
 **/